import React from 'react';
import './FormField.css';

interface FormFieldProps {
  label: string;
  name: string;
  type?: 'text' | 'number' | 'email' | 'tel';
  value: any;
  onChange: (value: any) => void;
  onBlur?: () => void;
  onValidate?: (fieldName: string, value: any, isRequired: boolean) => void;
  required?: boolean;
  placeholder?: string;
  error?: string;
  min?: number;
  max?: number;
  step?: number;
  minLength?: number;
  maxLength?: number;
  disabled?: boolean;
  children?: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  onValidate,
  required = false,
  placeholder,
  error,
  min,
  max,
  step,
  minLength,
  maxLength,
  disabled = false,
  children,
}) => {
  const handleBlur = () => {
    if (onValidate) {
      onValidate(name, value, required);
    }
    if (onBlur) {
      onBlur();
    }
  };

  const handleChange = (newValue: any) => {
    onChange(newValue);
    // Clear error on input (real-time validation)
    if (error && onValidate) {
      // Re-validate after a short delay to allow state update
      setTimeout(() => {
        onValidate(name, newValue, required);
      }, 100);
    }
  };

  return (
    <div className={`form-question ${error ? 'has-error' : ''}`}>
      <label htmlFor={name} className="question-label">
        {label} {required && <span className="required">*</span>}
      </label>
      {children || (
        <input
          type={type}
          id={name}
          name={name}
          className={`form-input ${type === 'number' ? 'number-input' : ''} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
          value={value || ''}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={handleBlur}
          required={required}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          minLength={minLength}
          maxLength={maxLength}
          disabled={disabled}
          aria-describedby={error ? `${name}-error` : undefined}
        />
      )}
      {error && (
        <span className="error-message" id={`${name}-error`} role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default FormField;

